<template>
    <Paginator
        :first="zeroIndexedFrom"
        :last="zeroIndexedTo"
        :rows="paginatorInfo.per_page"
        :total-records="paginatorInfo.total"
        @page="goToPage"
    />
    <p class="from-to-total text-center">{{ paginatorInfo.from }} to {{ paginatorInfo.to }} of {{ paginatorInfo.total }}</p>
</template>

<script setup lang="ts">
import { useEarlyDepositsPaged, useExpandedRows } from '@/services/early-deposit.service';
import type { PageState } from 'primevue/paginator';
import Paginator from 'primevue/paginator';
import { computed } from 'vue';

const { paginatorInfo, tablePageNum } = useEarlyDepositsPaged();
const { resetExpandedRows } = useExpandedRows();
const emit = defineEmits<{ pageChange: [page: number] }>();
const zeroIndexedFrom = computed(() => paginatorInfo.value.from - 1);
const zeroIndexedTo = computed(() => paginatorInfo.value.to - 1);

const goToPage = ({ page }: PageState) => {
    resetExpandedRows();
    tablePageNum.value = page + 1;
    emit('pageChange', page + 1);
};
</script>

<style scoped>
.from-to-total {
    word-spacing: 0.2ch;
}
</style>
